import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AiConfig } from './aiConfig';

const routes: Routes = [
  {
    path: '',
    component: AiConfig
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiConfigRoutingModule {}
